var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.activedContent),function(item,index){return _c('p',{key:index,staticClass:"content"},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }